import { withStyles } from '@material-ui/core/styles';
import SearchScanner from './SearchScanner';
import styles from './SearchScanner.styles';

export default withStyles(styles)(SearchScanner);
